import { useEffect, useState } from 'react';

// Breakpoint cutoffs used throughout the app. Keep in sync with
// styles/mobile.css media queries. If you change these, update both places.
export const BREAKPOINTS = {
  mobile:  768,   // < 768  → phone, small tablet portrait
  desktop: 1024,  // >= 1024 → laptop, iPad landscape
  // tablet = [768, 1024)
};

function read() {
  const w = typeof window === 'undefined' ? 1280 : window.innerWidth;
  return {
    width:     w,
    isMobile:  w <  BREAKPOINTS.mobile,
    isTablet:  w >= BREAKPOINTS.mobile && w < BREAKPOINTS.desktop,
    isDesktop: w >= BREAKPOINTS.desktop,
  };
}

export function useBreakpoint() {
  const [bp, setBp] = useState(read);

  useEffect(() => {
    let raf = 0;
    const onResize = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => setBp(read()));
    };
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
      cancelAnimationFrame(raf);
    };
  }, []);

  return bp;
}

export function useIsMobile() {
  return useBreakpoint().isMobile;
}
